import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log to console; in prod you could ship this to a telemetry endpoint
    console.error('Unhandled render error:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-inner">
            <h1>Etwas ist schiefgelaufen.</h1>
            <p>Die Seite konnte nicht angezeigt werden. Bitte lade die Anwendung neu.</p>
            {this.state.error && (
              <details>
                <summary>Technische Details</summary>
                <pre>{String(this.state.error && this.state.error.stack || this.state.error)}</pre>
              </details>
            )}
            <button type="button" onClick={this.handleReload} className="btn btn-primary">
              Neu laden
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
